import {
  TRANSACTION_SUMMARY_FETCH_REQUEST,
  TRANSACTION_SUMMARY_FETCH_REQUEST_SUCCESS,
  TRANSACTION_SUMMARY_FETCH_REQUEST_FAILURE,
  TRANSACTION_SUMMARY_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const transactionSummariesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TRANSACTION_SUMMARY_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TRANSACTION_SUMMARY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TRANSACTION_SUMMARY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TRANSACTION_SUMMARY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default transactionSummariesReducer;
